// @core/api/endpoints/chat/send_message.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MessageResponse,
  SendMessageRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Send a message
 * Sends a new message to the conversation. Supports text content, attachments, and thread replies. Real-time delivery via targeted Redis fan-out.
 */
export async function SendMessage(
  conversation_id: string,
  data: SendMessageRequest,
  options?: RequestOptions
): Promise<MessageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<MessageResponse>(requestPath, data, requestOptions);
}
